//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['widget'],
};
